<section class="nrc-testimonials">
  <h2 class="nrc-testimonials__title">What Homeowners Are Saying</h2>
  <div class="nrc-testimonials__divider"></div>
  <div class="nrc-testimonials__carousel">
    <button
      type="button"
      class="nrc-testimonials__nav nrc-testimonials__nav--prev"
      aria-label="Previous testimonials"
      [disabled]="atStart"
      [class.nrc-testimonials__nav--disabled]="atStart"
      (click)="prev()"
    >
      <img src="assets/images/chevron-left.svg" alt="" width="24" height="24" />
    </button>
    <swiper-container #swiperRef init="false" class="nrc-testimonials__swiper">
      <swiper-slide *ngFor="let t of testimonials; trackBy: trackByName">
        <article class="nrc-testimonials__card">
          <div class="nrc-testimonials__stars">
            <img
              *ngFor="let star of [1, 2, 3, 4, 5]; trackBy: trackByIndex"
              src="assets/images/star.svg"
              alt=""
              class="nrc-testimonials__star"
              width="20"
              height="20"
            />
          </div>
          <p class="nrc-testimonials__quote">"{{ t.quote }}"</p>
          <div class="nrc-testimonials__spacer" aria-hidden="true"></div>
          <p class="nrc-testimonials__name">{{ t.name }}</p>
          <p class="nrc-testimonials__location">{{ t.location }}</p>
        </article>
      </swiper-slide>
    </swiper-container>
    <button
      type="button"
      class="nrc-testimonials__nav nrc-testimonials__nav--next"
      aria-label="Next testimonials"
      [disabled]="atEnd"
      [class.nrc-testimonials__nav--disabled]="atEnd"
      (click)="next()"
    >
      <img src="assets/images/chevron-right.svg" alt="" width="24" height="24" />
    </button>
  </div>
  <div class="nrc-testimonials__divider nrc-testimonials__divider--bottom"></div>
</section>
